/**
 * View component for /sentiment-answers/new
 *
 * Creates a new sentimentAnswer from a copy of the defaultItem in the sentimentAnswer reducer
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { history, withRouter } from 'react-router-dom';

// import third-party libraries
import _ from 'lodash';

// import actions
import * as sentimentAnswerActions from '../sentimentAnswerActions.js';

// import global components
import Base from "../../../global/components/BaseComponent.js.jsx";

// import question components
import SentimentAnswerForm from '../components/SentimentAnswerForm.js.jsx';
import SentimentAnswerLayout from '../components/SentimentAnswerLayout.js.jsx';

class CreateSentimentAnswer extends Base {
  constructor(props) {
    super(props);
    this.state = {
      sentimentAnswer: _.cloneDeep(this.props.defaultSentimentAnswer)
      // NOTE: We don't want to actually change the store's defaultItem, just use a copy
    }
    this._bind(
      '_handleFormChange'
      , '_handleFormSubmit'
    );
  }

  _handleFormChange(e) {
    /**
     * This let's us change arbitrarily nested objects with one pass
     */
    let newSentimentAnswerState = _.update( this.state.sentimentAnswer, e.target.name, function() {
      return e.target.value;
    });
    this.setState({sentimentAnswer :newSentimentAnswerState});
  }


  _handleFormSubmit(e) {
    const { dispatch, history } = this.props;
    e.preventDefault();
    dispatch(sentimentAnswerActions.sendCreateSentimentAnswer(this.state.sentimentAnswer)).then((action) => {
      if(action.success) {
        dispatch(sentimentAnswerActions.invalidateList());
        history.push(`/sentiment-answers/${action.item._id}`)
      } else {
        // console.log("Response Error:");
        // console.log(action);
        alert("ERROR - Check logs");
      }
    });
  }

  render() {
    const { sentimentAnswer } = this.state;
    const isEmpty = (sentimentAnswer.name === null || sentimentAnswer.name === undefined);
    return (
      <SentimentAnswerLayout>
        <div className="flex">
          <section className="section">
            {isEmpty ?
              <h2> Loading...</h2>
              :
              <SentimentAnswerForm
                question={sentimentAnswer}
                cancelLink="/sentiment-answers"
                formTitle="Create Answer"
                formType="create"
                handleFormChange={this._handleFormChange}
                handleFormSubmit={this._handleFormSubmit}
                />
            }
          </section>
        </div>
      </SentimentAnswerLayout>
    )
  }
}

CreateSentimentAnswer.propTypes = {
  dispatch: PropTypes.func.isRequired
}

const mapStoreToProps = (store) => {
  /**
  * NOTE: Yote refer's to the global Redux 'state' as 'store' to keep it mentally
  * differentiated from the React component's internal state
  */
  return {
    defaultSentimentAnswer: store.sentimentAnswer.defaultItem
  }
}

export default withRouter(
  connect(
    mapStoreToProps
  )(CreateSentimentAnswer)
);



// WEBPACK FOOTER //
// modules/sentimentAnswer/views/CreateSentimentAnswer.js.jsx